<template>
  <div ref="lettingRollupTableRef" id="letting-rollup-table"></div>
</template>

<script>
var Tabulator = require("tabulator-tables");

export default {
  name: "MainRollupTable",
  data: function() {
    return {
      tabulator: null, //variable to hold your table
      tableData: [] //data for table to display
    };
  },
  computed: {
    letDocSetItems() {
      return this.$store.state.letDocSetItems;
    },
    rollUpColumns() {
      return this.$store.state.rollUpColumns;
    }
  },
  watch: {
    // update table if data changes
    tableData: {
      handler: function(newData) {
        this.tabulator.replaceData(newData);
      },
      deep: true
    }
  },
  beforeCreate() {
  },
  created: function() {
    // console.log("Test", this.$refs);
  },
  mounted() {
    // instantiate Tabulator when element is mounted
    this.tabulator = new Tabulator(this.$refs.lettingRollupTableRef, {
      data: this.letDocSetItems, // link data to table
      columns: this.rollUpColumns,      
      pagination: "local",
      paginationSize: 10,
      paginationSizeSelector: true,
      initialSort: [
        { column: "LetDate", dir: "desc" }, //sort by this first
        { column: "Status", dir: "asc" } //then sort by this second
      ],

      // When the component is initially loaded, filter it by the default array of libraries.
      initialFilter: [
        // { field: "Division", type: "in", value: divisionSortArray }
      ],
      layout: "fitColumns",
      responsiveLayout: "hide",

      index: "UniqueId",
      reactiveData: true,
      resizableColumns: "header",
      selectable: false,
      virtualDom: true,
      placeholder: "No data to show.",
      rowUpdated: function(row) {
        // When a row is changed, see if it needs to be pinned
        // freezePin(row)
      }
    }
    
    
    );
    console.log('mounted part done')
  }
};
</script>